import {
    normalizeDate, normalizeDateHour, normalizeHour,
    normalizeIban,
    normalizeImmatriculation,
    normalizeName, normalizeNumber,
    normalizeTel,
    normalizeYear,
} from '@amo/core/utils/normalize';
import PropTypes from 'prop-types';
import './text.scss';
import { getTranslation, showModal } from '@amo/core/utils/functions.js';
import _ from "lodash";

export const Text = (props) => {
    const {
        type = 'text',
        typeFormat,
        label,
        meta: { error },
        required = false,
        maxLength = '',
        minLength,
        input: { onChange, name, valueInput, value },
        disabled,
        help,
        helpTitle,
        customError,
        autocomplete,
        describedBy,
        phoneHint = typeFormat === 'tel',
        ...other
    } = props;
    const inputId = `text-${name}`;
    const errorId = `error-${name}`;
    const hintId = `hint-${name}`;
    // Indication du format attendu pour les numéros de téléphone (masquée si le champ est caché ou désactivé)
    const showPhoneHint = phoneHint && type !== 'hidden' && !disabled;
    const hasError = (valueInput || String(value)) && (error || customError) && type !== 'hidden';
    const normalizers = {
        date: normalizeDate,
        dateHour: normalizeDateHour,
        year: normalizeYear,
        immat: normalizeImmatriculation,
        tel: normalizeTel,
        iban: normalizeIban,
        text: normalizeName,
        hour: normalizeHour,
        number: normalizeNumber
    };

    const showPopup = () => {
        showModal({
            icon: 'info',
            html: help,
            title: helpTitle,
            ariaLabel: 'Aide',
        });
    }

    const changeData = (e) => {
        const normalize = normalizers[typeFormat];
        let normalizedValue = e.target.value;

        if (normalize) {
            normalizedValue = normalize(normalizedValue);
        }

        if (type === 'number') {
            // Limiter à 2 chiffres après la virgule pour le type 'number'
            const match = normalizedValue.match(/^(\d*\.\d{0,2})|\d*$/);
            normalizedValue = match ? match[0] : '';

            if(other.min && normalizedValue < other.min){
                normalizedValue = other.min;
            } else if(other.max && normalizedValue > other.max){
                normalizedValue = other.max;
            }
        }

        e.target.value = normalizedValue;
        onChange(e);
    };

    const pattern = type === 'date' ? '\\d{1,2}/\\d{1,2}/\\d{4}' : null;

    return (
        <div className="input-text-content">
            <div className={'d-flex justify-content-between'}>
                {label && <label htmlFor={inputId} className="text-start label-text mb-1 mx-0">
                        {label}
                        {required && <><sup className="text-danger" aria-hidden="true">*</sup><span className="visually-hidden"> (obligatoire)</span></>}
                    </label>
                }
                {help && <button type="button" className="float-end d-inline-block btn-help" style={{marginTop: '-5px'}} onClick={() => showPopup()} aria-label="Aide">?</button>}
            </div>
            <input
                id={inputId}
                name={name}
                type={type}
                required={required}
                aria-required={required ? 'true' : undefined}
                aria-invalid={hasError ? 'true' : undefined}
                aria-describedby={[describedBy, showPhoneHint ? hintId : null, hasError ? errorId : null].filter(Boolean).join(' ') || undefined}
                value={valueInput || value}
                maxLength={type === 'year' ? '4' : maxLength || ''}
                minLength={minLength || undefined}
                onChange={changeData}
                className={`form-control input-text input-${typeFormat}`}
                pattern={pattern}
                disabled={disabled}
                autoComplete={autocomplete}
                {...other}
            />
            {showPhoneHint &&
                <small id={hintId} className="d-block text-start text-grey mt-1">
                    {getTranslation('phoneFormatHint')}
                </small>
            }
            {hasError &&
                <small id={errorId} className="alert alert-danger invalid-feedback d-block error" role="alert">
                    {error || customError}
                </small>
            }
        </div>
    );
};
